<template>
  <title1 v-if="content.category === 1" :content="content"></title1>
  <title2 v-else-if="content.category === 2" :content="content"></title2>
  <title3 v-else-if="content.category === 3" :content="content"></title3>
  <title4 v-else-if="content.category === 4" :content="content"></title4>
  <title5 v-else-if="content.category === 5" :content="content"></title5>
  <title6 v-else-if="content.category === 6" :content="content"></title6>
  <title7 v-else-if="content.category === 7" :content="content"></title7>
  <title8 v-else-if="content.category === 8" :content="content"></title8>
  <title9 v-else-if="content.category === 9" :content="content"></title9>
</template>
<script>
/*
标题组件
*/
import title1 from "./title-1.vue";
import title2 from "./title-2.vue";
import title3 from "./title-3.vue";
import title4 from "./title-4.vue";
import title5 from "./title-center.vue";
import title6 from "./title-text.vue";
import title7 from "./title-image.vue";
import title8 from "./title-english.vue";
import title9 from "./title-block-center.vue";
export default {
  name: "titleIndex",
  components: {
    title1,
    title2,
    title3,
    title4,
    title5,
    title6,
    title7,
    title8,
    title9,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>
<style>


</style>
